export default "__VITE_ASSET__CRabfDvH__"